import { type DialogProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { AppInput } from "../../../shared/components/AppInput";
import { FolderNameChangeModal } from "../../Modals/FolderNameChangeModal";
import { TransferObjectModal } from "../../Modals/TransferObjectModal";
import { useClassifier } from "../hooks/use-classifier";
import { selectSelectedClassifier } from "../redux/selectors";
import styles from "./styles.module.css";

interface Props extends DialogProps {
  closeModal: () => void;
  childId?: string;
}

export const ClassifierFolderNameChange: FC<Props> = ({
  childId,
  closeModal,
  ...props
}) => {
  const selectedClassifier = useAppSelector(selectSelectedClassifier);
  const { onNameChange } = useClassifier();
  const { t } = useTranslation();
  return (
    <FolderNameChangeModal
      closeModal={closeModal}
      onClose={closeModal}
      onOk={() => {
        closeModal();
      }}
      {...props}
    >
      <div className={styles.container}>
        <AppInput
          value={selectedClassifier?.friendly_name as string}
          className={styles.input}
          onChange={onNameChange}
        />
      </div>
    </FolderNameChangeModal>
  );
};
